import Image from "next/image";
import type React from "react";

const KLARIFY_PLANTS = {
	happyPlant: "/svg/happy-klarify-plant.svg",
	optimisticPlant: "/svg/optimistic-klarify-plant.svg",
	disappointedPlant: "/svg/disappointed-klarify-plant.svg",
};

type PropTypes = Omit<React.ComponentProps<typeof Image>, "src" | "alt"> & {
	type?: "logo" | "text" | "text-white";
	logoType?: keyof typeof KLARIFY_PLANTS;
	alt?: string;
};

function KlarifyLogo({
	type = "logo",
	logoType = "happyPlant",
	// Brand name — identical in every supported locale, so it needs no catalog
	// entry. This default must stay translator-free: the component renders in
	// app/not-found.tsx, which sits outside the [locale] layout, so a translation
	// hook here has no provider and throws during SSR, turning every 404 into a
	// 500. Callers wanting richer alt text pass it in.
	alt = "Klarify",
	...props
}: PropTypes) {
	const logoSrc = {
		logo: KLARIFY_PLANTS[logoType],
		text: "/klarify-plant-with-text-teal.png",
		"text-white": "/klarify-plant-with-text-white.png",
	}[type];

	return (
		<Image
			alt={alt}
			src={logoSrc}
			width={100}
			height={100}
			{...props}
		/>
	);
}

export default KlarifyLogo;
